var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.callback}},[_vm._v("Max")])
}
var staticRenderFns = []

export { render, staticRenderFns }